/**
 * TYPES
 */
import {IAgent} from 'src/aggregates/agents/state.d';
import {ILoginMetrics} from 'src/aggregates/agents/state.d';
import {_aggregates} from 'src/aggregates/index.d';
import {IEvent} from 'src/aggregates/index.d';


/**
 * EXPORTS
 */

/**
 * Events types.
 */
export enum types
{
    AGENT_ADDED = 'AGENT_ADDED',
    AGENT_CREATED = 'AGENT_CREATED',
    AGENT_CREATING = 'AGENT_CREATING',
    AGENT_LOADED = 'AGENT_LOADED',
    AGENT_LOADING = 'AGENT_LOADING',
    AGENT_LOGIN_METRICS_FETCHED = 'AGENT_LOGIN_METRICS_FETCHED',
    AGENT_LOGIN_METRICS_FETCHING = 'AGENT_LOGIN_METRICS_FETCHING',
    AGENT_LOGIN_METRICS_NOT_FETCHED = 'AGENT_LOGIN_METRICS_NOT_FETCHED',
    AGENT_METRICS_PERIOD_SET = 'AGENT_METRICS_PERIOD_SET',
    AGENT_NOT_CREATED = 'AGENT_NOT_CREATED',
    AGENT_NOT_LOADED = 'AGENT_NOT_LOADED',
    AGENT_NOT_REMOVED = 'AGENT_NOT_REMOVED',
    AGENT_NOT_UPDATED = 'AGENT_NOT_UPDATED',
    AGENT_REMOVED = 'AGENT_REMOVED',
    AGENT_REMOVING = 'AGENT_REMOVING',
    AGENT_STARTING = 'AGENT_STARTING',
    AGENT_UPDATED = 'AGENT_UPDATED',
    AGENT_UPDATING = 'AGENT_UPDATING',
}


/**
 * Events interfaces.
 */
export interface IAgentAdded extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_ADDED;
    _target: string;
    agent: IAgent;
    type: types.AGENT_ADDED;
}

export interface IAgentCreated extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_CREATED;
    agent: IAgent;
    type: types.AGENT_CREATED;
}

export interface IAgentCreating extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_CREATING;
    type: types.AGENT_CREATING;
}

export interface IAgentLoaded extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_LOADED;
    type: types.AGENT_LOADED;
}

export interface IAgentLoading extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_LOADING;
    type: types.AGENT_LOADING;
}

export interface IAgentLoginMetricsFetched extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_LOGIN_METRICS_FETCHED;
    metrics: ILoginMetrics;
    type: types.AGENT_LOGIN_METRICS_FETCHED;
}

export interface IAgentLoginMetricsFetching extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_LOGIN_METRICS_FETCHING;
    type: types.AGENT_LOGIN_METRICS_FETCHING;
}

export interface IAgentLoginMetricsNotFetched extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_LOGIN_METRICS_NOT_FETCHED;
    type: types.AGENT_LOGIN_METRICS_NOT_FETCHED;
}

export interface IAgentMetricsPeriodSet extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_METRICS_PERIOD_SET;
    end: number;
    start: number;
    type: types.AGENT_METRICS_PERIOD_SET;
}

export interface IAgentNotCreated extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_NOT_CREATED;
    type: types.AGENT_NOT_CREATED;
}

export interface IAgentNotLoaded extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_NOT_LOADED;
    type: types.AGENT_NOT_LOADED;
}

export interface IAgentNotRemoved extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_NOT_REMOVED;
    _target: string;
    type: types.AGENT_NOT_REMOVED;
}

export interface IAgentNotUpdated extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_NOT_UPDATED;
    _target: string;
    type: types.AGENT_NOT_UPDATED;
}

export interface IAgentRemoved extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_REMOVED;
    _target: string;
    type: types.AGENT_REMOVED;
}

export interface IAgentRemoving extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_REMOVING;
    _target: string;
    type: types.AGENT_REMOVING;
}

export interface IAgentStarting extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_STARTING;
    type: types.AGENT_STARTING;
}

export interface IAgentUpdated extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_UPDATED;
    _target: string;
    agent: IAgent;
    type: types.AGENT_UPDATED;
}

export interface IAgentUpdating extends IEvent
{
    _aggregate: _aggregates.AGENTS;
    _name: types.AGENT_UPDATING;
    _target: string;
    type: types.AGENT_UPDATING;
}
